  <!-- Row 2: Tabs menu -->
   <nav class="w-fullbg-white border-b border-gray-200">
    <div class="flex px-4 sm:px-6">
      <!-- Header row -->
    <div class="flex items-left justify-between h-14">

      <!-- Logo / title (optional) -->
      <div class="font-semibold text-lg"></div>

      <!-- Hamburger (mobile only) -->
      <button
        class="md:hidden text-2xl"
        aria-label="Open menu"
        (click)="isMenuOpen = !isMenuOpen"
      >
        ☰
      </button>
    </div>

    <!-- Menu -->
      <div
      class="md:flex md:items-center md:gap-2 pt-1 pb-1"
      [ngClass]="{
        'hidden': !isMenuOpen,
        'flex flex-col gap-2 py-2': isMenuOpen
      }"
    >
        <a
          routerLink="/"
          routerLinkActive="tab-active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="tab-link"
        >
          Главная
        </a>

        <div class="flex flex-wrap items-center gap-2 mx-auto">
          <a
              *ngFor="let item of menu; trackBy: trackById"
              [routerLink]="['/', item.param]"
              routerLinkActive="tab-active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="tab-link"
            >
              {{ item.title }}
          </a>
        </div>

         <a
          routerLink="/contact"
          routerLinkActive="tab-active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="tab-link"
        >
          Связаться с нами
        </a>
      </div>
    </div>
  </nav>
